import { gsap, Power2 } from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__ReportStat extends ScrollItem__BlockDefault {
    stats = [];
    timeline;
    hasPlayed = false;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setupStats();
        this.onShow = () => {};
        this.onHide = () => this.hideStats();
        this.onMove = () => this.checkShow();
    }

    setupStats() {
        this.stats = [];

        GetBy.selector('[data-value]', this.item).forEach((el) => {
            const target = parseFloat(el.dataset.value) || 0;
            const text = el.querySelector('[data-text]');

            el.style.setProperty('--value', 0);
            el.style.setProperty('--progress-value', 0);
            if (text) text.textContent = '0%';

            this.stats.push({
                el,
                text,
                target,
                val: 0,
            });
        });

        this.timeline = gsap.timeline({ paused: true });

        this.stats.forEach((item, i) => {
            this.timeline.fromTo(
                item,
                { val: 0 },
                {
                    val: item.target,
                    duration: 1.2,
                    ease: Power2.easeOut,
                    onUpdate: () => this.updateStat(item),
                },
                i * 0.1
            );
        });
    }

    updateStat(item) {
        const progress = item.target ? item.val / item.target : 1;
        item.el.style.setProperty('--value', item.val);
        item.el.style.setProperty('--progress-value', progress);
        if (item.text) item.text.textContent = Math.round(item.val) + '%';
    }

    checkShow() {
        if (this.hasPlayed) return;
        if (this.progressToTop < 0.5) return;

        this.hasPlayed = true;
        this.showStats();
    }

    showStats() {
        this.timeline.restart();
    }

    hideStats() {
        this.hasPlayed = false;
        this.timeline.pause(0);
        this.stats.forEach((item) => {
            item.val = 0;
            this.updateStat(item);
        });
    }
}

Scroll._registerClass('ReportStat', ScrollItem__ReportStat);

export default ScrollItem__ReportStat;
